var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{staticClass:"xs12"},[_c('h1',[_c('small',[_vm._v("Статистика")])])]),(_vm.stat)?_c('v-flex',{staticClass:"xs12"},[_c('p',[_vm._v("Пользователей: "+_vm._s(_vm.stat.userCount))]),_c('p',[_vm._v("Персон: "+_vm._s(_vm.stat.personCount))])]):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }